import { render } from "./Singleocc.vue?vue&type=template&id=7c4e9de3&scoped=true"
import script from "./Singleocc.vue?vue&type=script&lang=js"
export * from "./Singleocc.vue?vue&type=script&lang=js"

import "./Singleocc.vue?vue&type=style&index=0&id=7c4e9de3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4e9de3"]])

export default __exports__